<script setup>
import DropdownWrapper from '@/components/shared/dropdown/DropdownWrapper.vue'
import Dropdown from '@/components/shared/dropdown/Dropdown.vue'
import DropdownMenu from '@/components/shared/dropdown/DropdownMenu.vue'
import ActionButton from '@/components/shared/buttons/ActionButton.vue'
import {useVisibilityToggle} from '@/composables/use-visibility-toggle.js'
import {useEmptySlotsCheck} from '@/composables/use-empty-slots-check.js'
import {ref, watchEffect} from 'vue'

//Emits and props
const emit = defineEmits([
  'open',
  'close',
])
defineProps({
  label: {
    type: String,
    default: '',
  },
  testId: {
    type: String,
    default: undefined,
  },
})

//Dropdown toggling
const wrapper = ref(null)
const menu = ref(null)
const {
  isVisible,
  toggle,
  hide,
} = useVisibilityToggle(wrapper)

//Check if default slot is empty
const {isSlotEmpty} = useEmptySlotsCheck()

//Watch open state
watchEffect(() => {
  if (isVisible.value) {
    emit('open')
  }
  else {
    emit('close')
  }
})
</script>

<template>
  <DropdownWrapper
    v-if="!isSlotEmpty"
    ref="wrapper"
  >
    <template v-if="isVisible">
      <ActionButton
        mobile-only
        type="text"
        icon="close"
        aria-label="Close"
        aria-expanded="true"
        @click.stop="hide()"
      />
      <ActionButton
        desktop-only
        :type="label ? 'secondary' : 'text'"
        :icon="!label ? 'more_horiz' : undefined"
        :label="label"
        is-slim
        aria-expanded="true"
        @click.stop="hide()"
      />
    </template>
    <ActionButton
      v-else
      :type="label ? 'secondary' : 'text'"
      :icon="!label ? 'more_horiz' : undefined"
      :label="label"
      :test-id="testId ? `${testId}Toggle` : undefined"
      aria-expanded="false"
      is-slim
      @click.stop="toggle()"
    />
    <Dropdown
      alignment="right"
      :class="$style.dropdown"
      :is-visible="isVisible"
    >
      <DropdownMenu
        ref="menu"
        :test-id="testId ? `${testId}Menu` : undefined"
        @click.stop="hide()"
      >
        <slot />
      </DropdownMenu>
    </Dropdown>
  </DropdownWrapper>
</template>

<style module lang="scss">
.dropdown {
  margin-top: 0.5rem;
  margin-right: 0.5rem;
  box-shadow: var(--box-shadow-strong);
}
</style>
